import {
  healthDashboardSchema,
  opsHealthSchema,
  type HealthDashboard,
  type OpsHealth,
} from '@console/types'
import { apiGet } from '../api.js'

export async function fetchHealthDashboard(): Promise<HealthDashboard> {
  return apiGet('/health/dashboard', healthDashboardSchema)
}

export async function fetchOpsHealth(): Promise<OpsHealth> {
  return apiGet('/ops-health', opsHealthSchema)
}
